var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('responsive-btn',{attrs:{"label":_vm.label || _vm.defaultLabel,"disabled":_vm.disabled,"icon":_vm.icons.mdiPlus},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }